import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api`;

const api = axios.create({
  baseURL: API_BASE_URL
});

api.interceptors.request.use((config) => {
  const savedSession = localStorage.getItem('pileSession');

  if (savedSession) {
    try {
      const session = JSON.parse(savedSession);

      if (session?.token) {
        config.headers.Authorization = `Bearer ${session.token}`;
      }
    } catch (error) {
      console.error('No fue posible leer la sesión guardada');
    }
  }

  return config;
});

// Obtener tareas.
// Si se recibe cursor, obtiene solo tareas posteriores a updatedAt + _id.
export const fetchTasks = async (cursor = null) => {
  const params = {};

  if (cursor?.updatedAt) {
    params.updatedAfter = cursor.updatedAt;
  }

  if (cursor?._id) {
    params.updatedAfterId = cursor._id;
  }

  const response = await api.get('/tasks', {
    params
  });

  return response.data;
};

// Obtener todos los usuarios
export const fetchUsers = async () => {
  const response = await api.get('/users');
  return response.data;
};

// Crear una nueva tarea
export const createTask = async (taskData) => {
  const response = await api.post('/tasks', taskData);
  return response.data;
};

// Actualizar una tarea
export const updateTask = async (taskId, updatedData) => {
  const response = await api.patch(`/tasks/${taskId}`, updatedData);
  return response.data;
};

// Eliminar una tarea
export const deleteTask = async (taskId) => {
  const response = await api.delete(`/tasks/${taskId}`);
  return response.data;
};

// Iniciar sesión
export const login = async (credentials) => {
  const response = await api.post('/auth/login', credentials);
  return response.data;
};

// Crear cuenta
export const register = async (userData) => {
  const response = await api.post('/auth/register', userData);
  return response.data;
};

// Verificar correo con código
export const verifyEmail = async ({ email, code }) => {
  const response = await api.post('/auth/verify-email', {
    email,
    code
  });

  return response.data;
};

// Solicitar código de acceso por correo
export const requestLoginCode = async (email) => {
  const response = await api.post('/auth/request-login-code', {
    email
  });

  return response.data;
};

// Iniciar sesión con código
export const loginWithCode = async ({
  email,
  code,
  acceptTerms = false
}) => {
  const response = await api.post('/auth/login-with-code', {
    email,
    code,
    acceptTerms
  });

  return response.data;
};

// Solicitar código de recuperación de contraseña
export const requestPasswordReset = async (email) => {
  const response = await api.post('/auth/request-password-reset', {
    email
  });

  return response.data;
};

// Restablecer contraseña
export const resetPassword = async ({ email, code, password }) => {
  const response = await api.post('/auth/reset-password', {
    email,
    code,
    password
  });

  return response.data;
};

// Obtener los workspaces disponibles para el usuario actual
export const fetchWorkspaces = async () => {
  const response = await api.get('/auth/workspaces');
  return response.data;
};

// Cambiar el workspace activo y obtener una nueva sesión
export const switchWorkspace = async (workspaceId) => {
  const response = await api.post('/auth/switch-workspace', {
    workspaceId
  });

  return response.data;
};

// Obtener proyectos del workspace actual
export const fetchProjects = async () => {
  const response = await api.get('/projects');
  return response.data;
};

// Crear un proyecto en el workspace actual
export const createProject = async ({ name, description = '' }) => {
  const response = await api.post('/projects', {
    name,
    description
  });

  return response.data;
};

// Validar filas antes de importar tareas
export const validateTaskImport = async (rows) => {
  const response = await api.post('/tasks/import/validate', {
    rows
  });

  return response.data;
};

// Importar tareas validadas
export const importTasks = async (rows) => {
  const response = await api.post('/tasks/import', {
    rows
  });

  return response.data;
};

// Exportar tareas del proyecto seleccionado
export const exportProjectTasks = async (projectId) => {
  const response = await api.get('/tasks/export', {
    params: {
      projectId
    },
    responseType: 'blob'
  });

  return {
    blob: response.data,
    contentDisposition: response.headers['content-disposition']
  };
};

